import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbButton as AbButtonInternal, convertButtonProps } from "abreact/misc/AbButton";
import { AbButtonType } from "absdk/commons/ui/misc/AbButtonType";
import * as React from "react";
export { AbButtonType };

/** @deprecated in favor of AbSize */
export let AbButtonSize = /*#__PURE__*/function (AbButtonSize) {
  AbButtonSize["DEFAULT"] = "";
  AbButtonSize["LARGE"] = "ab-button-large";
  AbButtonSize["SMALL"] = "ab-button-small";
  AbButtonSize["EXTRA_SMALL"] = "ab-button-extra-small";
  return AbButtonSize;
}({});

/**
 * Properties of the AbButton component.
 */

/**
 * The **AbButton** component is a basic button that performs an action when clicked.
 *
 * [[include:absdk/commons/ui/misc/AbButton.md]]
 */
const AbButton = (props, ref) => {
  return /*#__PURE__*/React.createElement(AbButtonInternal, _extends({}, convertButtonProps(props), {
    abRef: ref
  }));
};
const WrappedAbButton = /*#__PURE__*/React.forwardRef(AbButton);
export { WrappedAbButton as AbButton };
//# sourceMappingURL=AbButton.js.map
